var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"system-health-dashboard"}},[_c('SystemWithActiveAlert'),_c('SystemHealthRating')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }